import catalogModule from '../scripts/catalog/catalog.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(catalogModule);